export interface ActiveRoom {
  id: string;
  name: string;
}

/**
 * Pure helper to determine which room (if any) contains the given tile coordinates.
 */
export function getRoomAtTile(
  tileX: number,
  tileY: number,
  rooms: { id: string; name: string; cells: Set<string> }[]
): ActiveRoom | null {
  const key = `${tileX},${tileY}`;
  for (const room of rooms) {
    if (room.cells.has(key)) {
      return { id: room.id, name: room.name };
    }
  }
  return null;
}
